import api from 'service/api'

const dponetAPI = api.create('dponet', false)

const get = async () => {
  return await dponetAPI.get('/ai_inventory_risk_options')
}

export default { get }
